import * as HeaderServices from '../header-services/header-services';
import { updateBasketTotal, updateQuickBasketCount } from '../quick-basket/quick-basket-ui';
import { updateWishlistCount } from '../wishlist/wishlist-ui';

export async function updateData() {
    const data = await HeaderServices.getData();
    updateDataFromData(data);
}

export async function updateDataBuffered(shouldGetFreshData = false) {
    const data = await shouldGetFreshData ? HeaderServices.getData() : HeaderServices.getBufferedData();
    updateDataFromData(data);
}

export async function updateDataFromData(data) {
    updateWishlistCount({ cacheBuster:true });
    updateQuickBasketCount(-1,true);
    updateBasketTotal();

    if (data.isLoggedIn) {
        setIsLoggedInStates(selectAllLoggedInStatesElms());
        return;
    }

    setIsLoggedOutStates(selectAllLoggedInStatesElms());

}

export async function fetchBufferedHeaderData() {
    return await HeaderServices.getBufferedData();
}

// Needed because bootstrap breakpoint will override lower classes
const hiddenSelectors = ['d-none', 'd-sm-none', 'd-md-none', 'd-lg-none', 'd-xl-none', 'd-xxl-none'];

const hideElement = e => e.classList.add(...hiddenSelectors);
const showElement = e => e.classList.remove(...hiddenSelectors);


function setIsLoggedInStates(elements) {

    elements.isVisibleLoggedIn.forEach(showElement);
    elements.isHiddenLoggedIn.forEach(hideElement);

    elements.isVisibleLoggedOut.forEach(hideElement);
    elements.isHiddenLoggedOut.forEach(showElement);

}

function setIsLoggedOutStates(elements) {

    elements.isVisibleLoggedIn.forEach(hideElement);
    elements.isHiddenLoggedIn.forEach(showElement);

    elements.isVisibleLoggedOut.forEach(showElement);
    elements.isHiddenLoggedOut.forEach(hideElement);

}

function selectAllLoggedInStatesElms() {
    return {
        isVisibleLoggedIn: document.querySelectorAll('.is-visible-loggedin'),
        isHiddenLoggedIn: document.querySelectorAll('.is-hidden-loggedin'),
        isVisibleLoggedOut: document.querySelectorAll('.is-visible-loggedout'),
        isHiddenLoggedOut: document.querySelectorAll('.is-hidden-loggedout')
    };

}